/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SxProps, Theme } from '@mui/material';

export const orderItemTableV2DetailsImageSX: SxProps<Theme> = (theme) => ({
	maxWidth: theme.spacing(8),
	maxHeight: theme.spacing(8),
});
